/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actuator_Type_Recovery_WheelInputs */



/**
* | output |
* | --- |
* | "Recovery wheel" |
*
* @param {Actuator_Type_Recovery_WheelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const actuator_type_recovery_wheel = /** @type {((inputs?: Actuator_Type_Recovery_WheelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actuator_Type_Recovery_WheelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Recovery wheel")
	return /** @type {LocalizedString} */ ("Roue de récupération")
});